import { PATH_NAMES } from '../constants';

export const config = {
  shopsNextPath: PATH_NAMES.SELECT_PRODUCTS,
  productsPrevPath: PATH_NAMES.SELECT_ADDRESS,
  selectDatePrevPath: PATH_NAMES.SELECT_PRODUCTS,
  aboutYouPrevPath: PATH_NAMES.SELECT_DATE,

  reviewPrevPath: PATH_NAMES.ABOUT_YOU,
};
